import React from 'react';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import CaseListItem from './CaseListItem';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import OverlayLoading from '../../../../Components/OverlayLoading';
import styles from './CaseList.module.scss';

interface Props {
	flatData: any[];
	onLoadMore: () => void;
	onRefresh: () => void;
	isLoading: boolean;
	hasMoreData: boolean;
	renderItem?: (item: any) => React.ReactElement;
	isFlatDataLoading?: boolean;
}

const WRAPPER_ID = 'caseListWrapper';

const CaseList: React.FC<Props> = ({
	flatData,
	onLoadMore,
	onRefresh,
	isLoading,
	hasMoreData,
	renderItem,
	isFlatDataLoading = false,
}) => {
	useSocket(Socket.CASE_CREATED, onRefresh);

	return (
		<div className={styles.mainWrapper}>
			{isFlatDataLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={onRefresh}
					onLoadMore={onLoadMore}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					renderItem={
						renderItem ??
						(item => <CaseListItem item={item} onRefresh={onRefresh} />)
					}
				/>
			</ScrollContainer>
		</div>
	);
};

export default CaseList;
